import { SURFACE_LOWEST, FONT_STACK } from './chartTheme.js';

// Prépare une copie autonome d'un <svg> du DOM (fond opaque, police explicite) pour
// export/copie — sans ça le SVG source est transparent et perd les styles CSS externes
// une fois sorti de l'app (fichier téléchargé, presse-papiers, etc.).
// `inlineStyles` permet d'inliner des attributs sur des nœuds qui dépendent d'une classe
// CSS non disponible hors de l'app (ex: `[{ selector: '.foo', attributes: { fill: '#000' } }]`).
// `paddingRight` élargit le canevas à droite (px) sans déplacer le contenu, pour laisser
// un peu d'air après les labels les plus longs.
export const buildExportSvg = (svgEl, { fontFamily = FONT_STACK, backgroundColor = SURFACE_LOWEST, inlineStyles = [], paddingRight = 0 } = {}) => {
    const clone = svgEl.cloneNode(true);
    clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    clone.setAttribute('font-family', fontFamily);

    if (paddingRight > 0) {
        clone.setAttribute('width', String(Number(clone.getAttribute('width')) + paddingRight));
        const viewBox = clone.getAttribute('viewBox');
        if (viewBox) {
            const [x, y, w, h] = viewBox.split(/[\s,]+/).map(Number);
            clone.setAttribute('viewBox', `${x} ${y} ${w + paddingRight} ${h}`);
        }
    }

    const bg = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    bg.setAttribute('x', '0');
    bg.setAttribute('y', '0');
    bg.setAttribute('width', clone.getAttribute('width'));
    bg.setAttribute('height', clone.getAttribute('height'));
    bg.setAttribute('fill', backgroundColor);
    clone.insertBefore(bg, clone.firstChild);

    inlineStyles.forEach(({ selector, attributes }) => {
        clone.querySelectorAll(selector).forEach((node) => {
            Object.entries(attributes).forEach(([attr, value]) => node.setAttribute(attr, value));
        });
    });

    return new XMLSerializer().serializeToString(clone);
};

export const downloadSvg = (svgString, filename) => {
    const blob = new Blob([svgString], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

// Copie le SVG dans le presse-papiers si l'API le permet, sinon retombe sur un
// téléchargement. Retourne l'issue ('copied' | 'downloaded') pour piloter un libellé de bouton.
export const copyOrDownloadSvg = async (svgString, filename) => {
    try {
        if (!navigator.clipboard || typeof window.ClipboardItem === 'undefined') {
            throw new Error('Clipboard API SVG non supportée');
        }
        const blob = new Blob([svgString], { type: 'image/svg+xml' });
        await navigator.clipboard.write([new window.ClipboardItem({ 'image/svg+xml': blob })]);
        return 'copied';
    } catch (err) {
        downloadSvg(svgString, filename);
        return 'downloaded';
    }
};
